// @core/api/endpoints/project/get_project.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ProjectResponse,
} from '../../../types/project';

const BASE_PATH = '/project';

/**
 * Get project
 * Retrieves project details including configuration, methodology settings, and summary statistics. Requires membership in the project.
 */
export async function GetProject(
  project_id: string,
  options?: RequestOptions
): Promise<ProjectResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/projects/:project_id`;
  requestPath = requestPath.replace(':project_id', encodeURIComponent(project_id));
  const requestOptions = options;
  return client.get<ProjectResponse>(requestPath, { ...requestOptions });
}
